export const CategoryEnum = {
  EXPENSE: 1,
  REVENUE: 2,
  EXPENSE_AND_REVENUE: 3,
};
